import React, { useEffect, useState } from "react";

function ScrollTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
        onClick={scrollToTop}
        className="scroll-top"
        style={{
            display: visible ? "flex" : "none",
            border: "none",
            outline: "none",
            padding: 0,
            cursor: "pointer",
        }}
        >
    <i className="lni lni-chevron-up"></i>
    </button>
  );
}

export default ScrollTop;